module.exports = __webpack_public_path__ + "static/media/j.b01a260c.svg";